export const NAVIGATION = {
  settings: [
    {
      title: 'Broker',
      url: '/settings/broker',
    },
    {
      title: 'Users',
      url: '/settings/users',
    },
    {
      title: 'Teams',
      url: '/settings/teams',
    },
  ],
  'loan-files': [
    {
      title: 'Loan Files',
      url: '/loan-files',
    },
  ],
  account: [
    {
      title: 'Password',
      url: '/account',
    },
  ],
};

export const SUB_NAVIGATION = {};
